var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReturn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.304 11.85c6.84 1.195 11.987 6.4 11.987 12.64 0 1.218-.196 2.398-.564 3.516-1.512-5.523-5.92-9.792-11.423-10.946v8.124L4.709 14.59 15.304 3.994v7.856Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReturn);
export default ForwardRef;